export const STATES_LOAD = 'STATES_LOAD';
export const STATES_LOAD_SUCCESS = 'STATES_LOAD_SUCCESS';
export const STATES_LOAD_ERROR = 'STATES_LOAD_ERROR';
export const STATES_ADD = 'STATES_ADD';
export const STATES_ADD_SUCCESS = 'STATES_ADD_SUCCESS';
export const STATES_ADD_ERROR = 'STATES_ADD_ERROR';
export const STATES_UPDATE = 'STATES_UPDATE';
export const STATES_UPDATE_SUCCESS = 'STATES_UPDATE_SUCCESS';
export const STATES_UPDATE_ERROR = 'STATES_UPDATE_ERROR';
export const STATES_DELETE = 'STATES_DELETE';
export const STATES_DELETE_SUCCESS = 'STATES_DELETE_SUCCESS';
export const STATES_DELETE_ERROR = 'STATES_DELETE_ERROR';

export const STATE_UPDATE = 'STATE_UPDATE';
export const STATE_UPDATE_SUCCESS = 'STATE_UPDATE_SUCCESS';
export const STATE_UPDATE_ERROR = 'STATE_UPDATE_ERROR';
export const STATE_DELETE = 'STATE_DELETE';
export const STATE_DELETE_SUCCESS = 'STATE_DELETE_SUCCESS';
export const STATE_DELETE_ERROR = 'STATE_DELETE_ERROR';
